import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles, Button, IconButton } from '@material-ui/core'
import { ViewModule, ViewList } from '@material-ui/icons'
import { toggleView } from 'actions/signupForm'
import styles from './styles'
import language from 'utils/vast-languagepack'

export default connect(
  state => ({ viewSelected: state.signupForm.viewSelected }),
  dispatch => bindActionCreators({ toggleView }, dispatch)
)(
  withStyles(styles)(({ viewSelected, toggleView, icon, classes }) => {
    const ButtonComponent = icon ? IconButton : Button
    const iconClassName = icon ? null : classes.leftIcon
    const label =
      viewSelected === 'list' ? language.general.shared.calendarView : language.general.shared.listView

    return (
      <ButtonComponent
        onClick={toggleView}
        className={classes.toggleViewButton}
        aria-label={label}
      >
        {viewSelected === 'list' ? (
          <ViewModule className={iconClassName} />
        ) : (
          <ViewList className={iconClassName} />
        )}
        {icon ? null : label}
      </ButtonComponent>
    )
  })
)
